// --------------------------------------------------------------
// Created On: 2025-09-30
// Author: Zachary Thomas
//
// Last Modified: 2025-11-05
// Modified By: Zachary Thomas
//
// Copyright 2025 © Cornell Pump Company, All Rights Reserved
// --------------------------------------------------------------

import React from "react";
import Card from "../../../components/Card/Card";
import Error from "../../../components/Error/Error";
import PhoneNumberInput from "../../../components/PhoneNumberInput/PhoneNumberInput";
import styles from "./MfaRegistrationPhoneNumberForm.module.scss";

// Form for a user to register a phone number for MFA.
export default function MfaRegistrationPhoneNumberForm(props: Props): Component {
  // Check if the user pressed enter, if they did we attempt to register phone number.
  function checkPressEnter(e: React.KeyboardEvent): void {
    if (e.key === "Enter") {
      props.onSubmit();
    }
  }

  return (
    <form className={styles.body} onSubmit={(e) => e.preventDefault()} onKeyDown={(e) => checkPressEnter(e)}>
      <Card title="MFA Registration">
        <div className="px-3 px-lg-5 mb-4">
          <p className="mt-2">
            To help keep your account secure, please provide a mobile phone number. We will send a verification code to
            this number by text message whenever you sign in.
          </p>

          <div className="mt-2 mb-4">
            <PhoneNumberInput
              labelText=""
              inputClassName="w-100"
              phoneNumber={props.phoneNumber}
              callingCode={props.callingCode}
              disabled={props.disabled}
              onChangePhoneNumber={(phoneNumber) => props.onChangePhoneNumber(phoneNumber)}
              onChangeCallingCode={(callingCode) => props.onChangeCallingCode(callingCode)}
            />
          </div>

          <Error message={props.errorMessage} />

          <div className="my-4">
            <button
              data-test="cancel-mfa-phone-register-button"
              type="submit"
              id="cancel-mfa-register"
              className="btn btn-secondary"
              disabled={props.disabled}
              onClick={() => props.onCancel()}
            >
              Return to Login
            </button>

            <button
              data-test="login-button"
              type="submit"
              id="submit-login"
              className="btn btn-primary float-end"
              disabled={props.disabled}
              onClick={() => props.onSubmit()}
            >
              <span className="d-none d-lg-inline">Register Phone Number</span>
              <span className="d-inline d-lg-none">Register Number</span>
            </button>
          </div>
        </div>
      </Card>
    </form>
  );
}

interface Props {
  errorMessage: string;
  phoneNumber: string;
  callingCode: string;
  disabled?: boolean;
  onChangePhoneNumber: (phoneNumber: string) => void;
  onChangeCallingCode: (callingCode: string) => void;
  onCancel: () => void;
  onSubmit: () => void;
}
